import * as templates from './templates';

const createExistPetBtns = (existPets, existPetBody) => {
    var existPetItems = '';

    $.each(existPets, function (i, item) {
        existPetItems += `${templates.existPet({ displayName: item.Name, imgURL: item.PetPhoto, petId:item.Id, careClub:item.IsPatientCareClubMember, species:item.SpeciesName })}`;
    });
    existPetBody.prepend(existPetItems);
}

const createClientTypeBtns = (clientTypes,entrytBody) => {
    var clientTypeItems = '';

    $.each(clientTypes, function (i, item) {
        clientTypeItems  +=  `${templates.clientType({ displayName:item.DisplayName, imgURL:item.IconBaseUrl, imgURL2:item.IconHoverUrl, clientTypeId:item.ClientTypeId })}`;
    });
    entrytBody.prepend(clientTypeItems);
}


const createApptReasonBtns = (petApptReason, reasonTypetBody) => {
    var petApptResaonItems = '';

    $.each(petApptReason, function (i, item) {
        if(item.DisplayName !== '' || item.DisplayName !== null){
            petApptResaonItems  +=  `${templates.apptReason({ name:item.DisplayName, id:item.Id, appointmentTypeId: item.AppointmentTypeId })}`;
        }
    });
    reasonTypetBody.prepend(petApptResaonItems);
}

const createPetTypeBtns = (petTypes, petTypetBody, othersListy) => {
    var catTypesItems = '';
    var dogTypesItems = '';
    var otherPetTypesItems = '';

    $.each(petTypes, function (i, item) {
        if (item.SpeciesId == 1) {
            dogTypesItems += `${templates.petType({ displayName:item.DisplayName, imgURL:item.IconBaseUrl, imgURL2:item.IconHoverUrl, speciesId:item.SpeciesId })}`;
        }
        else if (item.SpeciesId == 2) {
            catTypesItems += `${templates.petType({ displayName:item.DisplayName, imgURL:item.IconBaseUrl, imgURL2:item.IconHoverUrl, speciesId:item.SpeciesId })}`;
        }
         else {
            otherPetTypesItems += `${templates.otherPetType({ displayName:item.DisplayName, speciesId:item.SpeciesId })}`;
            $('.js-vca-dropdown-button').show();
        }
    });
    petTypetBody.prepend(catTypesItems);
    petTypetBody.prepend(dogTypesItems);
    othersListy.append(otherPetTypesItems);
}

function createApptTypeBtns(petApptType, apptTypetBody) {
    var petApptTypesItems = '';
    var modals = '';

    $.each(petApptType, function (i, item) {
        if(item.DisplayName != '' && item.DisplayName != null){
            if(item.Id === 900 || item.Id === 911){
                petApptTypesItems  +=  `${templates.apptTypeContact({ name:item.DisplayName, imgURL:item.IconBaseUrl, imgURL2:item.IconHoverUrl, id:item.Id, appointmentTypeId:item.Id })}`;
                modals += `${templates.apptTypeModal({ name:item.DisplayName, id:item.Id, body:item.HtmlDescription })}`;
            }else if(item.IconBaseUrl != null && item.IconBaseUrl != '' && item.IconBaseUrl != "undefined"){
                petApptTypesItems  +=  `${templates.apptType({ name:item.DisplayName, imgURL:item.IconBaseUrl, imgURL2:item.IconHoverUrl, id:item.Id, appointmentTypeId:item.Id })}`;
            }else {
                petApptTypesItems  +=  `${templates.apptTypeNoImage({ name:item.DisplayName, id:item.Id, appointmentTypeId:item.Id })}`;
            }
        }

    });
    apptTypetBody.prepend(petApptTypesItems);
    apptTypetBody.append(modals);
}

function createWellnessBtns(wellnessResponse, wellnesstBody, isCareClubMember, iconUrl) {
    let wellnessDuelist= "";
    let wellnessAvalist= "";

  
    $.each(wellnessResponse, function (i, item) {


        let displayDate = new Date(item.DueDate).toLocaleDateString('en-US')
        let showCareClubIcon = 'hide';
        if(isCareClubMember){
            showCareClubIcon = 'show';
        }

        if(item.IsDue == true) {
            $('.js-wellness-section-due').show();
            if(item.DueDate == null){
                wellnessDuelist += `${templates.wellnessBtn({ displayName:item.DisplayName, IconUrl:iconUrl,wellnessTypeId:item.WellnessTypeId, id:item.Id, DueDate:displayDate, careClubIcon:showCareClubIcon  })}`;
            }
            else {
                wellnessDuelist += `${templates.wellnessBtnDueDate({ displayName:item.DisplayName, IconUrl:iconUrl,wellnessTypeId:item.WellnessTypeId, id:item.Id, DueDate:displayDate, careClubIcon:showCareClubIcon  })}`;
            }
        }else {
            $('.js-wellness-section-ava').show();
            if(item.DueDate == null){
                wellnessAvalist += `${templates.wellnessBtn({ displayName:item.DisplayName, IconUrl:iconUrl,wellnessTypeId:item.WellnessTypeId, id:item.Id, DueDate:displayDate, careClubIcon:showCareClubIcon  })}`;
            }
            else {
                wellnessAvalist += `${templates.wellnessBtnDueDate({ displayName:item.DisplayName, IconUrl:iconUrl,wellnessTypeId:item.WellnessTypeId, id:item.Id, DueDate:displayDate, careClubIcon:showCareClubIcon  })}`;
            }
        }
    });

    wellnesstBody.find('.js-wellness-section-due').append(wellnessDuelist);
    wellnesstBody.find('.js-wellness-section-ava').append(wellnessAvalist);
}

const createVerifyInputs = (petName, verifyBody) => {
    var petInputs = '';

    $.each(petName, function (i, item) {
        petInputs  +=  `${templates.petInputGroup({ displayName:item })}`;
    });
    verifyBody.prepend(petInputs);
}

export {
    createExistPetBtns,
    createClientTypeBtns,
    createApptReasonBtns,
    createPetTypeBtns,
    createApptTypeBtns,
    createWellnessBtns,
    createVerifyInputs
  }